import { useEffect, useRef, useState } from 'react';
import { mastershopHelpers } from '../../helpers/mastershopHelpers';

type Job = { id: string; user_id: string; status: string; page: number; last_error?: string; updated_at: string };
export function MastershopSyncStatus({ month, userId, onUpdate }: { month: string; userId?: string; onUpdate: () => void }) {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [error, setError] = useState('');
  const callback = useRef(onUpdate);
  callback.current = onUpdate;
  useEffect(() => {
    let stopped = false;
    let timer: ReturnType<typeof setTimeout>;
    let previous = '';
    async function poll() {
      const result = await mastershopHelpers.getSyncStatus(month, userId);
      if (stopped) return;
      if (result.success) {
        const latest = new Map<string, Job>();
        for (const job of (result.data || []) as Job[]) if (!latest.has(job.user_id)) latest.set(job.user_id, job);
        const next = [...latest.values()];
        const signature = JSON.stringify(next);
        if (previous && previous !== signature) callback.current();
        previous = signature;
        setJobs(next);
        setError('');
      } else setError('Não foi possível consultar o andamento da sincronização.');
      timer = setTimeout(poll, 10000);
    }
    void poll();
    return () => { stopped = true; clearTimeout(timer); };
  }, [month, userId]);
  const pending = jobs.filter(j => j.status === 'pending');
  const failed = jobs.filter(j => j.status === 'error');
  if (!error && !pending.length && !failed.length) return null;
  return <div role="status" className="relative p-3 mb-4 rounded-xl border border-gray-700 text-sm text-gray-300">
    {error || (pending.length > 0 ? `${pending.length} sincronização(ões) em andamento. O último total completo permanece visível até a conclusão.` : '')}
    {pending.some(j => j.last_error) && <p>Aguardando nova tentativa após falha da API.</p>}
    {failed.length > 0 && <p className="text-red-400">{failed.length} sincronização(ões) falharam. {userId ? failed[0].last_error : 'Confira as lojas dos vendedores.'} O total anterior foi preservado.</p>}
  </div>;
}
